import React from 'react';
import { PAGE_CONFIG } from './pageConfig';
import CommonPageRender from '@/pages/dashboard/components/PageContainer/CommonPageRender';
import './index.scss';
import { IPageConfigType } from '@/pages/dashboard/components/PageContainer/type';

const reqParams = '/overview/kpi';

const KpiOverview = () => (
  <>
    <CommonPageRender reqParams={reqParams} pageConfigInit={PAGE_CONFIG as IPageConfigType} />
  </>
);

export default KpiOverview;

